import api from '@/lib/axios';

export interface Company {
  id: string;
  tenantId: string;
  name: string;
  cnpj?: string | null;
  openingDate?: string | null;
  tradeName?: string | null;
  createdAt: string;
  updatedAt: string;
  clientsCount?: number;
}

export interface CreateCompanyDto {
  name: string;
  cnpj?: string;
  openingDate?: string;
  tradeName?: string;
}

export interface UpdateCompanyDto {
  name?: string;
  cnpj?: string;
  openingDate?: string;
  tradeName?: string;
}

export const companiesService = {
  async listCompanies(filters?: {
    includeClientsCount?: boolean;
  }): Promise<Company[]> {
    const params = new URLSearchParams();
    if (filters?.includeClientsCount) {
      params.append('includeClientsCount', 'true');
    }
    const suffix = params.toString();
    const response = await api.get<Company[]>(
      suffix ? `/companies?${suffix}` : '/companies',
    );
    return response.data;
  },

  async getCompany(id: string): Promise<Company> {
    const response = await api.get<Company>(`/companies/${id}`);
    return response.data;
  },

  async createCompany(data: CreateCompanyDto): Promise<Company> {
    const response = await api.post<Company>('/companies', data);
    return response.data;
  },

  async updateCompany(id: string, data: UpdateCompanyDto): Promise<Company> {
    const response = await api.patch<Company>(`/companies/${id}`, data);
    return response.data;
  },

  async deleteCompany(id: string): Promise<void> {
    await api.delete(`/companies/${id}`);
  },
};
